import PropTypes from 'prop-types'
import {List, Map} from 'immutable'

import Response from './views/Response'
import VaultExtension from './views/VaultExtension'
import {allResponseGroups} from '../../../../../lib/responsesHelper'

const ResponseResults = props => {
  const {
    firmName,
    logEvent,
    resetSearch,
    responseResults,
    userInitial,
    vaultExtension,
    vaultExtensionResults,
    ...otherProps
  } = props

  const hasVaultExtension = vaultExtensionResults && !vaultExtensionResults.isEmpty()
  const hasResponses = responseResults && !responseResults.isEmpty()

  if (!hasVaultExtension && !hasResponses) {
    return null
  } else {
    return (
      <div className='response-results'>
        <div className='section-header border-bottom'>IN YOUR EVERPLAN</div>
        <div>
          {hasVaultExtension && (
            <VaultExtension
              vaultExtension={vaultExtension}
              firmName={firmName}
              logEvent={logEvent}
              resetSearch={resetSearch}
              userInitial={userInitial}
            />
          )}
          {hasResponses && allResponseGroups(responseResults)
            .valueSeq()
            .map(responseResultGroup => (
              <Response
                key={responseResultGroup.getIn([0, 'id'])}
                logEvent={logEvent}
                responseResultGroup={responseResultGroup}
                {...otherProps}
              />
            ))}
        </div>
      </div>
    )
  }
}

ResponseResults.propTypes = {
  firmName: PropTypes.string,
  logEvent: PropTypes.func,
  resetSearch: PropTypes.func,
  responseResults: PropTypes.instanceOf(List),
  userInitial: PropTypes.string,
  vaultExtension: PropTypes.instanceOf(Map),
  vaultExtensionResults: PropTypes.instanceOf(List)
}

export default ResponseResults
